// "How many of each?" counter for the Build Your Own 6-Pack and 8-Pack.
// Markup and the why: snippets/bb-box-counter.liquid.
if (!customElements.get('bb-box-counter')) {
  customElements.define(
    'bb-box-counter',
    class BbBoxCounter extends HTMLElement {
      connectedCallback() {
        this.size = Number(this.dataset.size);
        this.rows = Array.from(this.querySelectorAll('.bb-box-counter__row'));
        this.rows.forEach((row) => {
          row.querySelectorAll('[data-step]').forEach((btn) =>
            btn.addEventListener('click', () => this.step(row, Number(btn.dataset.step)))
          );
        });
        this.render();
      }

      count(row) {
        return Number(row.querySelector('.bb-box-counter__count').textContent);
      }

      total() {
        return this.rows.reduce((sum, row) => sum + this.count(row), 0);
      }

      step(row, delta) {
        const next = this.count(row) + delta;
        if (next < 0 || this.total() + delta > this.size) return;
        row.querySelector('.bb-box-counter__count').textContent = next;
        this.render();
        if (this.total() === this.size) this.select();
      }

      // the variant whose name matches the counts ("4 Rainbow Magic + 2 Animal Pack")
      select() {
        const name = this.rows
          .filter((row) => this.count(row) > 0)
          .map((row) => `${this.count(row)} ${row.dataset.design}`)
          .join(' + ');
        const input = Array.from(this.closest('variant-selects').querySelectorAll('input[type="radio"]')).find(
          (i) => i.value === name
        );
        if (input && !input.checked) input.click();
      }

      render() {
        const left = this.size - this.total();
        this.rows.forEach((row) => {
          row.querySelector('[data-step="-1"]').disabled = this.count(row) === 0;
          row.querySelector('[data-step="1"]').disabled = left === 0;
        });
        this.querySelector('.bb-box-counter__status').textContent =
          left === 0 ? `${this.size} of ${this.size} ✓` : `${this.total()} of ${this.size}`;
        this.classList.toggle('bb-box-counter--done', left === 0);

        const button = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        const label = button?.querySelector('span');
        if (!label) return;
        if (left > 0) {
          if (!('bbText' in button.dataset)) {
            button.dataset.bbText = label.textContent;
            button.dataset.bbDisabled = button.disabled ? '1' : '';
          }
          button.disabled = true;
          label.textContent = `Pick ${left} more box${left === 1 ? '' : 'es'}`;
        } else if ('bbText' in button.dataset) {
          // back to a full pack: the same mix as before restores the button; a new mix
          // re-renders it through the variant change
          label.textContent = button.dataset.bbText;
          button.disabled = button.dataset.bbDisabled === '1';
          delete button.dataset.bbText;
          delete button.dataset.bbDisabled;
        }
      }
    }
  );
}
